import { Icon } from "@iconify/react";

function Search({ handleSearchInputChange, searchQuery, placeholder, bgDark }) {
  return (
    <div className="relative flex w-full items-center">
      <input
        type="search"
        placeholder={placeholder}
        onChange={handleSearchInputChange}
        value={searchQuery}
        className={`w-full rounded-md px-10 py-2 shadow-[rgba(50,_50,_105,_0.15)_0px_2px_5px_0px,_rgba(0,_0,_0,_0.05)_0px_1px_1px_0px] bg-[#FFF]/10 border-[1px] border-gray-600 ${
          bgDark ? "text-white" : "text-black"
        }`}
      />
      <Icon
        icon="ri:search-line"
        className={`absolute text-[20px] left-3 ${
          bgDark ? "text-white" : "text-blue-950"
        } cursor-pointer`}
      />
    </div>
  );
}

export default Search;
